export default "__VITE_ASSET__DaCVmm4C__"